module.exports = __webpack_public_path__ + "img/x.62eefd11.svg";